
import {combineReducers} from 'redux';
import office from './office';
import options from './options';
import product from './product';
import {reducer as form} from 'redux-form';
import departments from './institution';
import departmentAddress from './department';
import institutions from './postalCode';
import response from './submission';
import contact from './contact';

export default combineReducers( {
    form,
    office,
    options,
    product,
    departments,
    departmentAddress,
    institutions,
    response,
    contact
} );



// WEBPACK FOOTER //
// ./src/form/redux/modules/reducer.js